const SET_EDITED_SLUG = 'ts/EateryEditor/SET_EDITED_SLUG';
const SET_IS_SAVING = 'ts/EateryEditor/SET_IS_SAVING';

export default {
  SET_EDITED_SLUG,
  SET_IS_SAVING,
};
